var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';

var VehicleIncident = function () {
    function VehicleIncident(claim, caClaimExtension, vehicleIncident) {
        _classCallCheck(this, VehicleIncident);

        Object.defineProperty(this, '_claim', {
            enumerable: false,
            value: claim
        });

        Object.defineProperty(this, '_caClaimExtension', {
            enumerable: false,
            value: caClaimExtension
        });

        if (vehicleIncident) {
            _.extend(this, vehicleIncident);
        } else {
            this.driver = null;
            this.vehicle = null;
            this.passengers = [];
        }
    }

    _createClass(VehicleIncident, [{
        key: 'availableVehicles',
        value: function availableVehicles() {
            return this._caClaimExtension.availableVehicles(this.vehicle);
        }
    }, {
        key: 'availableDrivers',
        value: function availableDrivers() {
            return this._caClaimExtension.availableDrivers(this.driver);
        }
    }, {
        key: 'addPassenger',
        value: function addPassenger(passenger) {
            if (!passenger) {
                passenger = this._claim.createContact();
            }
            this.passengers.unshift(passenger);
        }
    }, {
        key: 'setNewDriver',
        value: function setNewDriver() {
            this.driver = this._claim.createContact();
        }
    }, {
        key: 'setNewVehicle',
        value: function setNewVehicle() {
            this.vehicle = this._caClaimExtension.createVehicle();
        }
    }, {
        key: 'removePassenger',
        value: function removePassenger(p) {
            var idx = this.passengers.indexOf(p);
            this.passengers.splice(idx, 1);
        }
    }, {
        key: 'getAvailablePassengers',
        value: function getAvailablePassengers() {
            return this._caClaimExtension.availablePassengers();
        }
    }]);

    return VehicleIncident;
}();

export default VehicleIncident;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/models/VehicleIncident.js
// module id = 1508
// module chunks = 0